import {
  ErrorMetadata,
  KazooError,
  IKazooErrorConstructable,
  initializeError,
} from "@kazoohr/types";

export function assertPageSizeIsSupported<T>(
  parameter: T | number,
  options: {
    message: string;
    errorMetadata: {} & ErrorMetadata;
    error?: IKazooErrorConstructable;
  } = {
    message: "Page size must be less than 200.",
    errorMetadata: { parameter: parameter },
  }
): asserts parameter is T {
  if (typeof parameter === "number" && parameter > 200) {
    throw initializeError(
      options.error || KazooError,
      options.message,
      options.errorMetadata
    );
  }
}
